export default __webpack_public_path__ + "static/img-ei-13-e102c1c3bb36272276b8391970e84d09.png";